import { useParams } from '@tanstack/react-router';

const useItemEditPermission = () => {
  const { eventId } = useParams({ strict: false });

  return { canEdit: !eventId };
};

export default useItemEditPermission;
